module.exports = __webpack_public_path__ + "a58b682eaeae48536711c552713780fc.png";